import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import {
    fetchAdvanceFilterOptions,
    fetchAdvanceBillsData,
    setFromDate,
    setToDate,
    setSelectedBranch,
    resetFilters,
    selectBranches,
    selectSelectedBranch,
    selectFromDate,
    selectToDate,
    selectLoading
} from './advanceBillReportsSlice';
import '../billreports.css';

const AdvanceBillReportsHeader = () => {
    const dispatch = useDispatch();

    // Redux selectors
    const branches = useSelector(selectBranches);
    const selectedBranch = useSelector(selectSelectedBranch);
    const fromDate = useSelector(selectFromDate);
    const toDate = useSelector(selectToDate);
    const loading = useSelector(selectLoading);

    // Initialize component - fetch filter options
    useEffect(() => {
        const storedClientid = localStorage.getItem('clientid');
        const rolename = localStorage.getItem('rolename') || 'CEO';
        if (storedClientid) {
            dispatch(fetchAdvanceFilterOptions({ rolename, clientname: storedClientid }));
        }
    }, [dispatch]);

    // Apply filters - fetch bill data
    const handleApplyFilters = () => {
        if (!fromDate || !toDate) {
            return;
        }

        dispatch(
            fetchAdvanceBillsData({
                fromDate,
                toDate,
                branchId: selectedBranch?.branch_id || '',
                status: ''
            })
        );
    };

    // Reset filters
    const handleResetFilters = () => {
        dispatch(resetFilters());
    };

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Advance Report
                </h2>
                <p className="text-color-secondary">View and analyze advance (online) bill reports with filtering options</p>
            </div>

            <Card className="mb-3 bill-reports-filter-card">
                <div className="flex flex-wrap align-items-end bill-reports-filter-row">
                    <div className="flex flex-column" style={{ flex: '1 1 150px', minWidth: '140px' }}>
                        <label htmlFor="fromDate">From Date <span className="text-red-500">*</span></label>
                        <Calendar id="fromDate" value={fromDate} onChange={(e) => dispatch(setFromDate(e.value))} dateFormat="dd-mm-yy" showIcon placeholder="From Date" className="w-full" showButtonBar />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 150px', minWidth: '140px' }}>
                        <label htmlFor="toDate">To Date <span className="text-red-500">*</span></label>
                        <Calendar id="toDate" value={toDate} onChange={(e) => dispatch(setToDate(e.value))} dateFormat="dd-mm-yy" showIcon placeholder="To Date" minDate={fromDate} className="w-full" showButtonBar />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 175px', minWidth: '155px' }}>
                        <label htmlFor="branch">Branch</label>
                        <Dropdown id="branch" value={selectedBranch} options={branches} onChange={(e) => dispatch(setSelectedBranch(e.value))} optionLabel="branch_name" placeholder="All Branches" className="w-full" filter showClear />
                    </div>

                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button label="Apply" icon="pi pi-check" className="p-button-primary" onClick={handleApplyFilters} disabled={!fromDate || !toDate || loading} loading={loading} />
                        <Button icon="pi pi-refresh" className="p-button-secondary" onClick={handleResetFilters} tooltip="Reset" />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default AdvanceBillReportsHeader;
